define([
	"dojo/_base/declare",
	"csi/_base/storage",
	"csi/reflection",
	"csi/view/ToolbarPluginSwitchboard"
], function (declare, storage, reflection, ToolbarPluginSwitchboard) {

	return declare(ToolbarPluginSwitchboard, {
		onChangeItem: function (/*csi.view.Widget*/view, /*Node*/node) {
			// summary: store selection for next time
			if (node) {
				storage.set(this.defAction.classToolbarPlugin, node.$URL);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Hide the switchboard as needed based on "SingleSectionReview"
		 */
		validatePlugin: function () {
			return !reflection.getClassConfig("Factory").getProperty("SingleSectionReview");
		},

		_onDefaultValue: function (/*String?*/preferredValue, /*String?*/defaultValue) {
			// summary: set to previous value unless first time
			var urlSection = storage.get(this.defAction.classToolbarPlugin);

			if (this.store && this.store.get(urlSection)) {
				defaultValue = urlSection;
			}

			this.inherited(arguments, [preferredValue, defaultValue]);
		}
	});
});